export default "/_next/static/node_modules/@riot-private/blades-ui/dist/blades/CharacterMovesList/assets/subLine.svg";